const CONFIG_DEV = {
  migrationOrgId: 3,
  migrationToolsEntity: 4671,
  migrationToolsV2Entity: 4748,
  fieldMappings: {
    4671: {
      tenantId: 'input_tSe2nm',
      userId: 'input_T66tYm',
      appId: 'input_TNKskB',
      appSecret: 'input_jB4cp7',
      sessionId: 'input_QHFx22',
      tenantName: 'input_RB8YSk',
      detailOperation: 'input_jns5b6'
    },
    4748: {
      tenantId: 'name',
      tenantName: 'input_nBm5yw',
      appId: 'input_e7bnHJ',
      appSecret: 'input_wFinNx',
      sessionId: 'input_DaFX8i',
      userId: 'input_23CFke',
      userName: 'input_T2Q3hC',
      detailOperation: 'input_wpeN7A',
      isStop: 'radio_ZNsehN', // 是否停服
      stoped: '77ZctQ' //停服
    }
  }
};
const CONFIG_TEST = {
  migrationOrgId: 3,
  migrationToolsEntity: 1062,
  migrationToolsV2Entity: 1125,
  fieldMappings: {
    1062: {
      tenantId: 'input_DNSZhT',
      userId: 'input_iY43xb',
      appId: 'input_tcKJK2',
      appSecret: 'input_7Wr8wc',
      sessionId: 'input_mmFrEy',
      tenantName: 'name',
      detailOperation: 'input_mtfRr8'
    },
    1125: {
      tenantId: 'input_GYmipF',
      tenantName: 'input_AE3wCd',
      appId: 'input_B6yeWt',
      appSecret: 'input_2KTYKR',
      sessionId: 'input_82C2PZ',
      userId: 'input_f7KksY',
      userName: 'input_hsz64K',
      detailOperation: 'input_4XQrRJ',
      isStop: 'radio_87tYDF', // 是否停服
      stoped: 'FTW5HR' //停服
    }
  }
};
const CONFIG_PRODUCTION = {
  migrationOrgId: 31720,
  migrationToolsEntity: 201,
  migrationToolsV2Entity: 203,
  fieldMappings: {
    201: {
      tenantId: 'input_CpNeNX',
      userId: 'input_Q8HWkA',
      appId: 'input_FNR3T4',
      appSecret: 'input_BwfHCf',
      sessionId: 'input_tFGBpy',
      tenantName: 'input_Xt68WJ',
      detailOperation: 'input_4XsJnK'
    },
    203: {
      tenantId: 'input_wpCzM7',
      tenantName: 'input_Dxmjba',
      appId: 'input_BsYZtQ',
      appSecret: 'input_bMiYHB',
      sessionId: 'input_KxxP5b',
      userId: 'input_crF274',
      userName: 'input_4Zfyat',
      detailOperation: 'input_hWay56',
      isStop: 'radio_RfEMRk', // 是否停服
      stoped: 'AjacxG' //停服
    }
  }
};
const ENV_CONFIGS = {
  dev: CONFIG_DEV,
  test: CONFIG_TEST,
  production: CONFIG_PRODUCTION
};
const modeLists = ['production', 'pc2', 'matrixProd'];
const mode = import.meta.env.MODE;
const env = modeLists.includes(mode) ? 'production' : mode;
// 获取当前环境完整配置
export function getEnvConfig() {
  return ENV_CONFIGS[env] || {};
}
// 获取当前环境映射配置
export function getFieldMappings() {
  return ENV_CONFIGS[env]?.fieldMappings || {};
}

// 获取当前环境特定实体的字段映射
export function getEntityFieldMapping(entity) {
  return getFieldMappings()[entity] || {};
}
